import VForm from './VForm'

VForm.install = function install (Vue) {
  Vue.component(VForm.name, VForm)
}

export default VForm



// WEBPACK FOOTER //
// ./src/components/VForm/index.js